/**
 * TEMPORARY UI-ONLY PATCH for RolesPermissionsCards.
 *
 * The backend/DB sends some pages with a `sub_pages` array that just
 * duplicates that same page's own `actions` (one sub_page per action, each
 * holding a single action identical to its parent's). For MASTER ADMIN today
 * that's `view-organization-management`: its `actions` already list
 * `view-organization-management-organizations` / `-roles` / `-users`, and its
 * `sub_pages` repeats the exact same three as full pages with one action
 * each — so the direct-actions table and the sub_page blocks below it show
 * the same three permissions twice.
 *
 * Root cause is server-side (the menu should not populate `sub_pages` there
 * at all). Until that's fixed, a tree_key listed here has its `sub_pages`
 * emptied PURELY for display in RolesPermissionsCards (see
 * stripDuplicateSubPages) — the real `menu` object handed to onChange/saved
 * to the backend is untouched — purely visual.
 */
// eslint-disable-next-line import/prefer-default-export
export const DUPLICATE_SUBPAGES_TREE_KEYS: string[] = ["view-organization-management"];
